<template>
  <!-- 看板 -->
  <div class="report">
    <div class="top_center">
      <div>
        本页展示为Demo数据
      </div>
      <div class="top flex">
        <div style="font-size:16px;" class="top_left font_bo flex">
          <div class="cursor" :class="titlestuts == 1 ? 'top_left_list' : ''" @click="tits(1)">订单详情</div>
          <div class="cursor" :class="titlestuts == 2 ? 'top_left_list' : ''" @click="tits(2)">联盟客详情</div>
          <div class="cursor" :class="titlestuts == 3 ? 'top_left_list' : ''" @click="tits(3)">重复订单详情</div>
        </div>
        <div class="top1 flex">
          <div class="top_centers flex">
            <div class="top_center_one">
              <p class="sz12 co70">国家/地区</p>
              <el-dropdown trigger="click" @visible-change='iconclick(1)'>
                <div class="sz16 scect flex">美国(UTC-5)<i v-if="iconstuts" class="el-icon-caret-right"></i><i v-else
                    class="el-icon-caret-bottom"></i></div>
                <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                  <div class="nologins cursor">
                    <el-dropdown-item>
                      <div class="nologins_list center cursor" :class="listStutszs == 1 ? 'listba' : ''">美国(UTC-5)</div>
                    </el-dropdown-item>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="top_center_two">
              <p class="sz12 co70">币种</p>
              <el-dropdown trigger="click" @visible-change='iconclick(2)'>
                <div class="sz16 scect flex">美元<i v-if="iconstuts2" class="el-icon-caret-right"></i><i v-else
                    class="el-icon-caret-bottom"></i></div>
                <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                  <div class="nologins cursor">
                    <el-dropdown-item>
                      <div class="nologins_list center cursor" :class="listStutszs == 1 ? 'listba' : ''">美元 </div>
                    </el-dropdown-item>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div class="title_top flex">
        <div class="title flex">
          <div class="title_input">
            <el-input v-if="titlestuts == 1" v-model="receiverName" disabled placeholder="搜索原始订单号"></el-input>
            <el-input v-if="titlestuts == 2" v-model="receiverName2" disabled placeholder="搜索联盟客姓名/ID/推广网站"></el-input>
            <el-input v-if="titlestuts == 3" v-model="receiverName3" disabled placeholder="搜索订单号"></el-input>
            <div class="icons">
              <img src="../../assets/img/foll/search.png" alt="">
            </div>
          </div>
          <div class="title_ks">
            <div class="block">
              <el-date-picker prefix-icon="iconoic" v-model="values" type="daterange" disabled range-separator="至"
                start-placeholder="选择开始日期" end-placeholder="选择结束日期" @change="startDa">
              </el-date-picker>
              <img src="@/assets/img/emil/rl.png" alt="" />
              <!-- <i class="el-icon-date data_icon"></i> -->
            </div>
          </div>
          <div class="title_scslt" v-if="titlestuts != 3">
            <el-select v-model="isRead" clearable placeholder="联盟平台" disabled @clear="delValue">
              <el-option label="AvantLink" :value="'AvantLink'"></el-option>
              <el-option label="ShareASale" :value="'ShareASale'"></el-option>
            </el-select>
          </div>
        </div>
        <div class="title_qu">
          <div class="title_query ba6e coff center ru5 cursor" @click="searchs1">查询</div>
        </div>
      </div>
      <div class="tablelist ru5 baff" v-if="titlestuts == 1">

        <el-table :data="tableData1.slice((currentPage - 1) * pageSize, currentPage * pageSize)" style="width: 100%"
          :header-cell-style="{ background: 'rgba(167, 169, 192, 0.25)', color: '#000000' }"
          :default-sort="{ prop: 'date', order: 'descending' }">
          <el-table-column prop="time" label="日期" sortable width=""></el-table-column>
          <el-table-column prop="ysoder" label="原始订单号" min-width=""></el-table-column>
          <el-table-column prop="je" label="分销金额" sortable width=""></el-table-column>
          <el-table-column prop="jyje" label="佣金金额" sortable width=""></el-table-column>
          <el-table-column prop="ptfy" label="平台费用" sortable width=""></el-table-column>
          <el-table-column prop="id" label="联盟客ID" width=""></el-table-column>
          <el-table-column prop="name" show-overflow-tooltip label="联盟客姓名" width="180">
            <template slot-scope="props">
              {{ props.row.name }}
            </template>
          </el-table-column>
          <el-table-column prop="url" show-overflow-tooltip label="推广网站" min-width="180"></el-table-column>
          <el-table-column prop="type" label="联盟客类型" min-width=""></el-table-column>
          <el-table-column prop="pt" label="联盟平台" width="">
            <!-- <template slot-scope="scope">
              {{scope.row.pt == 0?'AvantLink':'ShareASale'}}
            </template> -->
          </el-table-column>
          <el-table-column prop="ptoder" show-overflow-tooltip label="平台订单号"></el-table-column>
        </el-table>
      </div>

      <div class="pages" v-if="tableData1.length && titlestuts == 1">
        <paging :total="tableData1.length" :page.sync="currentPage" :limit.sync="pageSize" :small="true" @changeSize="() => {
          currentPage = 1;
        }
          " @pagination="currentChangeTwo">
        </paging>
        <!-- <el-pagination align='center' @size-change="handleSizeChange" @current-change="handleCurrentChange" prev-text="上一页" next-text="下一页" :current-page="currentPage" :page-sizes="[1,5,10,20,]" :page-size="pageSize" layout="total, prev, pager, next" :total="tableData1.length">
        </el-pagination> -->
      </div>
      <div class="tablelist ru5 baff" v-if="titlestuts == 2">
        <el-table :data="tableData2.slice((currentPage2 - 1) * pageSize2, currentPage2 * pageSize2)" style="width: 100%"
          :header-cell-style="{ background: 'rgba(167, 169, 192, 0.25)', color: '#000000' }"
          :default-sort="{ prop: 'date', order: 'descending' }">
          <el-table-column prop="id" label="联盟客ID" width=""></el-table-column>
          <el-table-column prop="name" show-overflow-tooltip label="联盟客姓名" width="180">

          </el-table-column>
          <el-table-column prop="url" show-overflow-tooltip label="推广网站" min-width="180"></el-table-column>
          <el-table-column prop="type" label="联盟客类型"></el-table-column>
          <el-table-column prop="pt" label="联盟平台" width=""></el-table-column>
          <el-table-column prop="fxje" label="分销金额" sortable width=""></el-table-column>
          <el-table-column prop="jezb" label="金额占比" sortable width=""></el-table-column>
          <el-table-column prop="order" label="分销订单数" sortable min-width="95"></el-table-column>
          <el-table-column prop="zb" label="订单数占比" sortable min-width="95"></el-table-column>
          <el-table-column prop="yjje" label="佣金金额" sortable width=""></el-table-column>
          <el-table-column prop="fy" label="平台费用" sortable width=""></el-table-column>
          <el-table-column prop="zc" label="总支出" sortable width=""></el-table-column>
        </el-table>
      </div>
      <div class="pages" v-if="tableData2.length && titlestuts == 2">
        <paging :total="tableData2.length" :page.sync="currentPage2" :limit.sync="pageSize2" :small="true" @changeSize="() => {
          currentPage = 1;
        }
          " @pagination="currentChange2">
        </paging>
        <!-- <el-pagination align='center' @size-change="handleSizeChange2" @current-change="handleCurrentChange2" prev-text="上一页" next-text="下一页" :current-page="currentPage2" :page-sizes="[1,5,10,20,]" :page-size="pageSize2" layout="total, prev, pager, next" :total="tableData2.length">
        </el-pagination> -->
      </div>
      <div class="tablelist ru5 baff" v-if="titlestuts == 3">
        <div style="font-size:14px;margin: 10px 0;" class="font_bo"> 重复订单 数据概览</div>
        <el-table :data="tableData3.slice((currentPage3 - 1) * pageSize3, currentPage3 * pageSize3)" style="width: 100%"
          :header-cell-style="{ background: 'rgba(167, 169, 192, 0.25)', color: '#000000' }"
          :default-sort="{ prop: 'date', order: 'descending' }">
          <el-table-column prop="time" label="时间" width=""></el-table-column>
          <el-table-column prop="order" label="订单号" width=""></el-table-column>
          <el-table-column prop="id" label="联盟客ID" width=""></el-table-column>
          <el-table-column prop="url" show-overflow-tooltip label="推广网站" min-width="180"></el-table-column>
          <el-table-column prop="name" show-overflow-tooltip label="联盟客姓名" width="250"></el-table-column>
          <el-table-column prop="je" label="分销金额" sortable width=""></el-table-column>
          <el-table-column prop="type" label="联盟客类型" min-width="90"></el-table-column>
          <el-table-column prop="pt" label="联盟平台" width=""></el-table-column>
        </el-table>

      </div>
      <div class="pages" v-if="tableData3.length && titlestuts == 3">
        <paging :total="tableData3.length" :page.sync="currentPage3" :limit.sync="pageSize3" :small="true" @changeSize="() => {
          currentPage3 = 1;
        }
          " @pagination="currentChange3">
        </paging>
        <!-- <el-pagination align='center' @size-change="handleSizeChange3" @current-change="handleCurrentChange3" prev-text="上一页" next-text="下一页" :current-page="currentPage3" :page-sizes="[1,5,10,20,]" :page-size="pageSize3" layout="total, prev, pager, next" :total="tableData3.length">
        </el-pagination> -->
      </div>
      <div class="title_top flex" v-if="titlestuts == 3">
        <div class="title flex">
          <div class="title_input">
            <el-input v-model="receiverName4" disabled placeholder="搜索联盟客姓名/ID/推广网站"></el-input>
            <div class="icons">
              <img src="../../assets/img/foll/search.png" alt="">
            </div>
          </div>
          <div class="title_ks">
            <div class="block">
              <el-date-picker prefix-icon="iconoic" v-model="values" type="daterange" disabled range-separator="至"
                start-placeholder="选择开始日期" end-placeholder="选择结束日期" @change="startDa">
              </el-date-picker>
              <img src="@/assets/img/emil/rl.png" alt="" />
              <!-- <i class="el-icon-date data_icon"></i> -->
            </div>
          </div>
          <div class="title_scslt">
            <el-select v-model="isRead2" clearable placeholder="联盟平台" disabled @clear="delValue">
              <el-option label="AvantLink" :value="'AvantLink'"></el-option>
              <el-option label="ShareASale" :value="'ShareASale'"></el-option>
            </el-select>
          </div>
        </div>
        <div class="title_qu">
          <div class="title_query ba6e coff center ru5 cursor" @click="searchs2">查询</div>
        </div>
      </div>
      <div class="tablelist ru5 baff" v-if="titlestuts == 3">
        <div style="font-size:14px;margin: 10px 0;" class="font_bo"> 重复订单 联盟客概览</div>
        <div>
          <el-table :data="tableData4.slice((currentPage4 - 1) * pageSize4, currentPage4 * pageSize4)" style="width: 100%"
            :header-cell-style="{ background: 'rgba(167, 169, 192, 0.25)', color: '#000000' }"
            :default-sort="{ prop: 'date', order: 'descending' }">
            <el-table-column prop="id" label="联盟客ID" width=""></el-table-column>
            <el-table-column prop="name" show-overflow-tooltip label="联盟客姓名"></el-table-column>
            <el-table-column prop="url" show-overflow-tooltip label="推广网站"></el-table-column>
            <el-table-column prop="order" label="重复订单数" sortable></el-table-column>
            <el-table-column prop="je" label="重复订单分销金额" sortable></el-table-column>
            <el-table-column prop="pt" label="联盟平台" width=""></el-table-column>
            <el-table-column prop="type" label="联盟客类型"></el-table-column>
            <el-table-column style="width:120%" type="expand" label="订单号" width="80">
              <template slot-scope="props">
                <el-form label-position="right" inline class="demo-table-expand">
                  <el-form-item label="">
                    <p class="tab_p">{{ props.row.ordernum }}</p>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div style="padding-bottom: 50px;" class="pages" v-if="tableData4.length && titlestuts == 3">
        <paging :total="tableData4.length" :page.sync="currentPage4" :limit.sync="pageSize4" :small="true" @changeSize="() => {
          currentPage4 = 1;
        }
          " @pagination="currentChange4">
        </paging>
        <!-- <el-pagination align='center' @size-change="handleSizeChange4" @current-change="handleCurrentChange4" prev-text="上一页" next-text="下一页" :current-page="currentPage4" :page-sizes="[1,5,10,20,]" :page-size="pageSize4" layout="total, prev, pager, next" :total="tableData4.length">
        </el-pagination> -->
      </div>
      <!-- <div class="pages" v-if="tableData3.length && titlestuts == 3">
        <paging :total="total" :page.sync="currentPage" :limit.sync="pagesize" :small="true" @changeSize="() => { currentPage = 1; }" @size-change="handleSizeChange" @current-change="handleCurrentChange"></paging>
      </div> -->
    </div>
  </div>
</template>
<script>
import paging from "@/components/paging";
import axios from 'axios'
import { EventSourcePolyfill } from "event-source-polyfill";
export default {
  components: {
    paging
  },
  data() {
    return {
      iconstuts: true,
      iconstuts2: true,
      listStutszs: 1,
      titlestuts: 1,
      tab3tuts: true,
      receiverName: '',
      receiverName2: '',
      receiverName3: '',
      receiverName4: '',
      isClickSearch: false, // 当点击搜索时 对底部分页进行判断
      pagesize: 10,
      values: '',
      values: '',
      isRead: '',
      isRead2: '',
      tableData: [],
      mCTableData: [],
      pt: '',
      ordersum: '',
      validParam: localStorage.getItem('validParam'),
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      currentPage: 1, // 当前页码
      total: 0, // 总条数
      pageSize: 10, // 每页的数据条数\
      tableDataAnother: [],
      currentPage2: 1, // 当前页码
      total2: 0, // 总条数
      pageSize2: 10, // 每页的数据条数\
      currentPage3: 1, // 当前页码
      total3: 0, // 总条数
      pageSize3: 5, // 每页的数据条数\
      currentPage4: 1, // 当前页码
      total4: 0, // 总条数
      pageSize4: 5, // 每页的数据条数\
      startDate: '',
      endDate: '',
      texthonder: '搜索原始订单号',
      tableData5: [{
        id: '12987122',
        name: '好滋好味鸡蛋仔',
        category: '江浙小吃、小吃零食',
        desc: '荷兰优质淡奶，奶香浓而不腻',
        address: '上海市普陀区真北路',
        shop: '王小虎夫妻店',
        shopId: '10333'
      }, {
        id: '12987123',
        name: '好滋好味鸡蛋仔',
        category: '江浙小吃、小吃零食',
        desc: '荷兰优质淡奶，奶香浓而不腻',
        address: '上海市普陀区真北路',
        shop: '王小虎夫妻店',
        shopId: '10333'
      }, {
        id: '12987125',
        name: '好滋好味鸡蛋仔',
        category: '江浙小吃、小吃零食',
        desc: '荷兰优质淡奶，奶香浓而不腻',
        address: '上海市普陀区真北路',
        shop: '王小虎夫妻店',
        shopId: '10333'
      }, {
        id: '12987126',
        name: '好滋好味鸡蛋仔',
        category: '江浙小吃、小吃零食',
        desc: '荷兰优质淡奶，奶香浓而不腻',
        address: '上海市普陀区真北路',
        shop: '王小虎夫妻店',
        shopId: '10333'
      }],
      isend: false, //是否加载完
      textCount: 0,
      timer: null,
      messageTipShow: false,
    }
  },
  mounted() {
    if (this.validParam !== 'bgxq') {
      this.$bus.$emit('showNopermiss', true)
    }
    // this.listmap()
    axios.post("/api/addgoods",
      {
        usernameL: 'sdfsdfsd',
        page: this.size,
        pageNum: this.currentPage,
      }
    ).then((res) => {
      this.tableData1 = res.data.data
      this.tableData1.map((item, index) => {
        if (item.name) {
          item.name = item.name.substring(0, 2) + "*****" + item.name.substring(item.name.length - 2)
        }
        if (item.url) {
          item.url = item.url.substring(0, 2) + "*****" + item.url.substring(item.url.length - 2)
        }
        if (item.ysoder) {
          item.ysoder = item.ysoder.substring(0, 2) + "*****" + item.ysoder.substring(item.ysoder.length - 2)
        }
        if (item.id) {
          item.id = item.id.substring(0, 2) + "*****" + item.id.substring(item.id.length - 2)
        } if (item.ptoder) {
          item.ptoder = item.ptoder.substring(0, 2) + "*****" + item.ptoder.substring(item.ptoder.length - 2)
        }
        if (item.je) {
          item.je = Number(item.je * 1.1).toFixed(2)
        }
        if (item.jyje) {
          item.jyje = Number(item.jyje * 1.1).toFixed(2)
        }



      })
    })

  },
  methods: {
    iconclick(e) {
      if (e == 1) {
        this.iconstuts = !this.iconstuts
      } else {
        this.iconstuts2 = !this.iconstuts2
      }

    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
    },
    handleSizeChange2(val) {
      this.currentPage2 = 1;
      this.pageSize2 = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val;
    },
    handleSizeChange3(val) {
      this.currentPage3 = 1;
      this.pageSize3 = val;
    },
    handleCurrentChange3(val) {
      this.currentPage3 = val
    },
    handleSizeChange4(val) {
      this.currentPage4 = 1;
      this.pageSize4 = val;
    },
    handleCurrentChange4(val) {
      this.currentPage4 = val
    },
    tab3click() {
      let mc = this.pt;
      let IIN = this.ordersum;
      if ((mc != null && mc != '') || (IIN != null && IIN != '')) {
        let newItem = [];
        if (mc != '' && IIN != '') {
          this.tableData3.map(function (item) {
            if (item.pt.search(mc) != -1 && item.ordersum.search(IIN) != -1) {
              newItem.push(item);
            }
          });
        } else if (mc != '' || IIN != '') {
          this.tableData3.map(function (item) {
            if ((item.pt.search(mc) != -1 && mc != '') || (item.ordersum.search(IIN) != -1 && IIN != '')) {
              newItem.push(item);
            }
          });
        }
        this.mCTableData = newItem;
      } else {
        this.mCTableData = this.tableData3;
      }
    },
    tits(e) {
      this.titlestuts = e
      this.receiverName2 = ''
      this.receiverName = ''
      this.receiverName3 = ''
      this.receiverName4 = ''
      this.isRead = ''
      this.isRead2 = ''
      if (e == 1) {
        axios.post("/api/addgoods",).then((res) => {
          this.tableData1 = res.data.data
          this.tableData1.map((item, index) => {
            if (item.name) {
              item.name = item.name.substring(0, 2) + "*****" + item.name.substring(item.name.length - 2)
            }
            if (item.url) {
              item.url = item.url.substring(0, 2) + "*****" + item.url.substring(item.url.length - 2)
            }
            if (item.ysoder) {
              item.ysoder = item.ysoder.substring(0, 2) + "*****" + item.ysoder.substring(item.ysoder.length - 2)
            }

          })
        })
      } else if (e == 2) {
        axios.post("/api/addgoods2",).then((res) => {
          this.tableData2 = res.data.data
          this.tableData2.map((item, index) => {
            if (item.name) {
              item.name = item.name.substring(0, 2) + "*****" + item.name.substring(item.name.length - 2)
            }
            if (item.url) {
              item.url = item.url.substring(0, 2) + "*****" + item.url.substring(item.url.length - 2)
            }
            if (item.id) {
              item.id = item.url.substring(0, 2) + "*****" + item.url.substring(item.id.length - 2)
            }
            if (item.fxje) {
              item.fxje = Number(item.fxje * 1.1).toFixed(2)
            }
            if (item.yjje) {
              item.yjje = Number(item.yjje * 1.1).toFixed(2)
            }

          })
        })
      } else if (e == 3) {
        axios.post("/api/addgoods3",).then((res) => {
          this.tableData3 = res.data.data
          this.tableData3.map((item, index) => {
            if (item.name) {
              item.name = item.name.substring(0, 2) + "*****" + item.name.substring(item.name.length - 2)
            }
            if (item.url) {
              item.url = item.url.substring(0, 2) + "*****" + item.url.substring(item.url.length - 2)
            }
            if (item.id) {
              item.id = item.url.substring(0, 2) + "*****" + item.url.substring(item.id.length - 2)
            }
            if (item.order) {
              item.order = item.order.substring(0, 2) + "*****" + item.order.substring(item.order.length - 2)
            }
            if (item.je) {
              item.je = Number(item.je * 1.1).toFixed(2)
            }


          })
        })
        axios.post("/api/addgoods4",).then((res) => {
          this.tableData4 = res.data.data
          this.tableData4.map((item, index) => {
            if (item.name) {
              item.name = item.name.substring(0, 2) + "*****" + item.name.substring(item.name.length - 2)
            }
            if (item.url) {
              item.url = item.url.substring(0, 2) + "*****" + item.url.substring(item.url.length - 2)
            }
            if (item.id) {
              item.id = item.url.substring(0, 2) + "*****" + item.url.substring(item.id.length - 2)
            }
            if (item.je) {
              item.je = Number(item.je * 1.1).toFixed(2)
            }
          })
        })
      }
    },
    formatter(row, column) {
      return row.address;
    },
    startDa(e) {
      this.startDate = e[0].getFullYear() + '-' + (e[0].getMonth() + 1) + '-' + e[0].getDate();
      this.endDate = e[1].getFullYear() + '-' + (e[1].getMonth() + 1) + '-' + e[1].getDate();
    },
    delValue() { },
    searchs1() {
      if (this.titlestuts == 1) {
        let keyword = this.receiverName
        let isRead = this.isRead
        if (isRead !== '' || keyword !== '') {
          this.tableData1 = this.tableData1.filter(function (agentlist) {
            return agentlist.pt === isRead || agentlist.ysoder === keyword
          })
        } else {
          axios.post("/api/addgoods").then((res) => {
            this.tableData1 = res.data.data
          })
        }
      } else if (this.titlestuts == 2) {
        let keyword = this.receiverName2
        let isRead = this.isRead
        if (isRead !== '' || keyword !== '') {
          this.tableData2 = this.tableData2.filter(function (agentlist) {
            return agentlist.pt === isRead || agentlist.name === keyword || agentlist.id == keyword || agentlist.url == keyword
          })
        } else {
          axios.post("/api/addgoods2").then((res) => {
            this.tableData2 = res.data.data
          })
        }
      } else if (this.titlestuts == 3) {
        let keyword = this.receiverName3
        if (keyword !== '') {
          this.tableData3 = this.tableData3.filter(function (agentlist) {
            return agentlist.order === keyword
          })
        } else {
          axios.post("/api/addgoods3").then((res) => {
            this.tableData3 = res.data.data
          })
        }
      }

    },
    searchs2() {
      let keyword = this.receiverName4
      let isRead = this.isRead2
      if (isRead !== '' || keyword !== '') {
        this.tableData4 = this.tableData4.filter(function (agentlist) {
          return agentlist.pt === isRead || agentlist.name === keyword || agentlist.id == keyword || agentlist.url == keyword
        })
      } else {
        axios.post("/api/addgoods4").then((res) => {
          this.tableData4 = res.data.data
        })
      }
    },
    searchs() {

    },
    currentChangeTwo() { },
    currentChange4() { },
    currentChange3() { },
    currentChange2() { },
  }
}
</script>
<style lang="less" scoped>
.tab_p {
  word-wrap: break-word;
  word-break: break-all;
}

.pages {
  margin: 30px 0 50px 0;
}

.listba {
  // background:#a6a8bf;
  background: rgba(166, 168, 191, 0.25) !important;
}

.nologins {
  width: 120px;
  border-radius: 14px;

  .nologins_title {
    box-sizing: border-box;
    width: 100%;
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid rgba(64, 64, 64, 0.25);
    padding-left: 7px;
  }

  .nologins_list {
    width: 100%;
    height: 32px;
    line-height: 32px;
    margin: 10px 0;
  }
}

.report {
  width: 100%;
  height: 100%;
  padding-top: 69px;
  background: #fafafd;
  box-sizing: border-box;

  .top {
    width: 100%;
    height: 84px;
    border-bottom: 2px solid rgba(166, 168, 191, 0.25);
    align-items: center;
    position: relative;
    margin-bottom: 24px;
    justify-content: space-between;

    .top_left {
      align-items: center;
      height: 100%;

      div {
        margin-right: 60px;
        padding-bottom: 10px;
      }

      .top_left_list {
        color: #be3c6e;
        border-bottom: 2px solid #be3c6e;
      }
    }

    .top1 {
      width: 30%;
      height: 84px;
      align-items: center;
      position: absolute;
      right: 0;

      .top_centers {
        width: 300px;
        position: absolute;
        right: 0;

        .top_center_one {
          width: 40%;
          margin-right: 20%;
          border-bottom: 1px solid;

          .scect {
            width: 120px;
            position: relative;
            align-items: center;
            padding-bottom: 3px;
            margin-top: 5px;

            i {
              position: absolute;

              right: 0;
            }
          }
        }

        .top_center_two {
          width: 40%;
          border-bottom: 1px solid;

          .scect {
            width: 120px;
            position: relative;
            align-items: center;
            padding-bottom: 3px;
            margin-top: 5px;

            i {
              position: absolute;
              right: 0;
            }
          }
        }
      }
    }
  }

  .top_right {
    width: 300px;

    .top_center_one {
      width: 40%;
      margin-right: 20%;

      .scect {
        border-bottom: 1px solid;
        position: relative;

        i {
          position: absolute;
          right: 0;
        }
      }
    }

    .top_center_two {
      width: 40%;

      .scect {
        border-bottom: 1px solid;
        position: relative;

        i {
          position: absolute;
          right: 0;
        }
      }
    }
  }

  .title_top {
    margin-bottom: 15px;

    .title {
      height: 56px;
      border: 1px solid #d5d5d5;
      border-radius: 5px;
      background: #fff;

      div {
        height: 100%;
      }

      .title_input {
        width: 300px;
        height: 54px;
        border-right: 1px solid #d5d5d5;
        position: relative;

        .icons {
          width: 16px;
          height: 56px;
          position: absolute;
          right: 10px;
          top: 0;
          display: flex;
          align-items: center;

          img {
            width: 16px;
            height: 16px;
          }
        }
      }

      .title_ks {
        width: 500px;
        border-right: 1px solid #d5d5d5;
        position: relative;

        img {
          width: 34px;
          height: 30px;
          position: absolute;
          left: 30px;
          top: 50%;
          margin-top: -15px;
        }
      }

      .title_scslt {
        width: 284px;
      }
    }

    .title_qu {
      height: 56px;
      display: flex;
      align-items: center;
      padding-left: 24px;

      .title_query {
        width: 130px;
        height: 40px;
        font-size: 16px;
        line-height: 40px;
      }
    }
  }

  .tablelist {
    width: 100%;
    padding: 10px;
  }

  .tab3 {
    display: flex;

    p {
      min-width: 60px;
    }

    span {
      display: inline-block;
      width: 50px;
      text-align: center;
    }
  }
}

@media screen and (min-width: 1000px) and (max-width: 2000px) {
  .top_center {
    width: 1600px;
    margin: 0 auto;
  }
}

@media screen and (min-width: 2000px) and (max-width: 3000px) {
  .top_center {
    width: 1920px;
    margin: 0 auto;
  }
}

.top_center {
  height: 100vh;
}



/deep/ textarea {
  padding-right: 45Px;
  height: 100% !important;
  border-radius: 10px !important;
}

::-webkit-scrollbar {
  width: 0px !important;
  height: 0px !important;
  background-color: #fff;
}

.aibox {
  position: fixed;
  display: flex;
  flex-direction: row;
  height: 100%;
  min-height: 500px;
  border-radius: 10px 0 0 10px;
  box-shadow: 1px 0 2px 2px #ecf5ff;
  top: 0;
  right: 0;
  z-index: 999 !important;
  background-color: #f8e4eb;
  box-sizing: border-box;

  #aibtn {
    position: absolute;
    width: 75Px;
    height: 75Px;
    top: 10%;
    left: -75Px;
    text-align: center;
    cursor: pointer;
    border-radius: 50% 0% 0% 50%;
    background-color: #f8e4eb;
    z-index: 9999 !important;

    .block1 {
      width: 16Px;
      height: 16Px;
      z-index: 9998 !important;
      position: absolute;
      right: 0;
      top: -16Px;

      #aiblock1 {
        width: 100%;
      }
    }


    .block2 {
      width: 16Px;
      height: 16Px;
      z-index: 9998 !important;
      position: absolute;
      right: 0px;
      bottom: -15Px;

      #aiblock2 {
        width: 100%;
      }
    }


    #bot {
      width: 50Px;
      margin-top: 22Px;
    }
  }
}

#aibtn3 {
  position: fixed;
  width: 60Px;
  height: 60Px;
  border-radius: 50%;
  background-color: #34e7e7;
  right: 20Px;
  bottom: 150Px;
  z-index: 9999 !important;
  cursor: pointer;

  img {
    margin-top: 8px;
    width: 100%;
  }

  &:hover {
    transform: scale(1.3);
    transition: all .4s;
  }

  @keyframes aiaction2 {

    100% {
      scale: (1.3);
    }
  }

  @keyframes aiaction {

    0%,
    50% {
      transform: translateY(-20px);
    }

    25%,
    75% {
      transform: translateY(0);
    }
  }
}

.left {
  width: 200Px;
  border-right: 2px solid #fff
}

.addchat {
  height: 80PX;
  width: 250Px;
  position: absolute;
  bottom: 0;
  padding: 20Px 20Px 20Px 25Px;

  .addbtn {
    width: 150Px;
    height: 40Px;
    border: 5px solid transparent;
    border-radius: 10px;
    background-image: linear-gradient(to right, #fff, #fff), linear-gradient(to right, red, #578aef);
    background-color: #d4f1ff;
  }
}

.right {
  width: 375Px;
  height: 100%;

  .messageTip {
    // width: 150Px;
    padding: 0 15Px;
    height: 60Px;
    line-height: 60Px;
    position: absolute;
    text-align: center;
    z-index: 999;
    top: 40%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 8Px;
    background-color: #be3c6e;
    color: #fff;
    font-weight: bold;

  }
}

.title {
  position: relative;
  // top: 0;
  color: #fff;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: linear-gradient(to right, #a9b7c5 50%, rgba(190, 60, 110, 1));

  .top-minus {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: 600;
    position: absolute;
    right: 40px;
    top: 0;
    cursor: pointer;
    color: #fff
  }

  .top-close {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: 600;
    position: absolute;
    right: 10px;
    top: 0;
    cursor: pointer;
    color: #fff
  }
}

.contentbox {
  box-sizing: border-box;
  // position: absolute;
  width: 100%;
  height: calc(100% - 170px);
  flex-grow: 2;
  // height: 100%;
  // top: 0;
  // padding-bottom: 130Px;
  overflow: hidden;
  overflow-y: scroll;


  .loadingbox {
    width: 50px;
  }

  .loadingbox>div {
    width: 10px;
    height: 10px;
    background-color: #33e5e5;
    border-radius: 50%;
    display: inline-block;
    animation: action 1.5s infinite ease-in-out;
    animation-fill-mode: both;
  }

  .loadingbox .point1 {
    animation-delay: -0.3s;
  }

  .loadingbox .point2 {
    animation-delay: -0.1s;
  }

  @keyframes action {

    0%,
    80%,
    100% {
      transform: scale(0);
    }

    40% {
      transform: scale(1.0);
    }
  }

}


.chat-list {
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: 0 auto;
  margin-top: 1rem;
  margin-bottom: 1rem;
  overflow: auto;

  .tastrule_center {
    white-space: pre-wrap;
  }

  >div {
    display: flex;
    margin-top: 1rem;

    >div {
      max-width: 250Px;
      padding: 0.6rem;
      opacity: 0.8;

      font-size: 0.9rem;
      font-family: FZLanTingHei-L-GBK;
      font-weight: 400;
      color: #c5e7ff;
      text-align: start;
    }

    .bot {
      padding: 10Px 9Px;
      letter-spacing: .5px;
      font-weight: 500;
      font-size: 14px;
      font-family: Verdana, Arial, Helvetica, sans-serif;
      align-self: flex-end;
      background: #fff;
      color: #000;
      border-radius: 16px 16px 16px 16px;
      text-transform: uppercase;
    }

    .user {
      color: #fff;
      background-color: #be3c6e;
      padding: 10Px 9Px;
      letter-spacing: .5px;
      font-weight: 500;
      font-size: 14px;
      font-family: Verdana, Arial, Helvetica, sans-serif;
      align-self: flex-start;
      border-radius: 16px 16px 16px 16px;
    }

    .img1 {
      width: 50Px;
    }

    .img2 {
      width: 2rem;
      height: 2rem;
      margin-left: 1rem;
    }
  }

  >.botbox {
    align-self: flex-start;
  }

  >.userbox {
    align-self: flex-end;
  }

  // >div:nth-of-type(odd) {
  //   align-self: flex-end;
  // }

  // >div:nth-of-type(even) {
  //   align-self: flex-start;
  // }
}

.el-textarea {
  position: absolute;
  height: 100px;
  width: 94%;
  bottom: 8px;
  right: 3%;
}


/* 1.过渡动画 */
@keyframes axisX {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0px);
  }
}

@keyframes axisX2 {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes axisX3 {
  0% {
    opacity: 0;
  }

  70% {
    opacity: 0;
  }

  80% {
    opacity: 0.7;
  }

  90% {
    opacity: 0.9;
  }

  100% {
    opacity: 1;
  }
}

@keyframes widthX {
  from {
    width: 0px;
  }

  to {
    width: 200Px;
  }
}

@keyframes opacityLing {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

/* 2. 过渡类名 */
/* 开始 */
.ai1-enter-active {
  animation: axisX 1s;
}

/* 结束 */
.ai1-leave-active {
  animation: axisX .5s reverse;
}

/* 开始 */
.ai2-enter-active {
  animation: axisX 1s;
}

/* 结束 */
.ai2-leave-active {
  animation: axisX .5s reverse;
}


.ai3-enter-active {
  animation: axisX3 1s;
}

/* 结束 */
.ai3-leave-active {
  animation: axisX2 0s reverse;
}

.left-enter-active {
  animation: widthX .7s;
}

.left-leave-active {
  animation: widthX .7s reverse;
}

.close-enter-active {}

.close-leave-active {
  animation: opacityLing 1s;
}
</style>
<style lang="less">
.report {
  .title_input .el-input__inner {
    height: 100%;
    border: none;
  }

  .el-select .el-input__inner {
    border: none;
  }

  // .el-select > .el-input{
  //   display: none;
  // }
  .el-pagination__sizes {
    display: none !important;
  }

  .el-pagination__total {
    display: none !important;
  }

  .el-input--suffix .el-input__inner {
    height: 100%;
  }

  .el-select {
    width: 100%;
  }

  .el-select>.el-input {
    width: 100%;
    height: 100%;
  }

  .el-pager li.active {
    color: #000;
    font-family: "OPPOSans-R";
    src: url("../../assets/ttf/OPPOSans-R.ttf");
  }

  .el-range-editor.el-input__inner {
    width: 100%;
    border: none;
    padding-left: 50px;
  }

  .el-date-editor .el-range-separator {
    height: 100%;
    line-height: 48px;
  }

  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    color: #fff;
    background: #be3c6e;
  }

  .el-drawer__wrapper {
    top: 70px;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    margin: 0;
  }

  // .pagination-container{
  //   ba
  // }
  .el-pagination__total {
    display: none !important;
  }

  .el-pagination__sizes {
    display: none !important;
  }

  .btn-next {
    min-width: 52px !important;
    height: 22px !important;
    font-size: 12px !important;
    text-align: center !important;
    line-height: 22px !important;
    background: rgba(168, 168, 191, 0.25) !important;
    border-radius: 6px 6px 6px 6px !important;
    padding-right: 9.6px;
  }

  .btn-prev {
    min-width: 52px !important;
    height: 22px !important;
    font-size: 12px !important;
    text-align: center !important;
    line-height: 22px !important;
    background: #e5e6ee !important;
    background: rgba(168, 168, 191, 0.25) !important;
    padding: none !important;
    padding-left: 5px !important;
    padding-left: 9.6px !important;
  }

  .el-pager {
    margin: 0 15px;
    background: #fafafd;
  }

  .el-pager li.active {
    background: #e5e6ee;
    color: #000;
    height: 22px;
    line-height: 22px;
    border-radius: 6px;
    margin: 0 5px;
  }

  .el-pager li {
    background: none;
    height: 22px;
    line-height: 22px;
    font-weight: 400;
    margin: 0 5px;
  }

  .el-pagination {
    text-align: right !important;
  }

  .pagination-container {
    padding: none !important;
  }

  .el-pagination .btn-next {
    padding-right: 12px;
  }

  // .el-icon-arrow-up:before {
  //   content: "";
  // }
  .cent_input {
    .el-input--suffix .el-input__inner {
      padding-left: 30px;
    }
  }

  .el-pagination button:disabled {
    border-radius: 5px;
  }

  .el-pagination .btn-prev {
    border-radius: 5px;
  }

  .el-pagination button:hover {
    color: #303133;
  }

  .el-pager li:hover {
    color: #303133;
  }

  // .el-icon-arrow-up:before {
  //   content:"";
  // }
  .el-pagination button,
  .el-pagination span:not([class*="suffix"]) {
    line-height: 22px;
  }

  .el-icon-arrow-right:before {
    content: "\";
    color: #000;
    font-size: 16px;
  }
}

.bulletinBoard {
  .el-dropdown {
    width: 100%;
  }
}

.el-dropdown-menu__item {
  padding: 0 !important;
  color: #000;
}

.bulletinBoard.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #000;
  background: none;
}

.el-table th.el-table__cell>.cell {
  font-weight: 400;
}
</style>